var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWaveSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_25291_16278)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_25291_16278",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_25291_16278",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_25291_16278",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAASPSURBVGhDY/z//z/DUAZMUHrIglEPDDQY9cBAg0HngYULF83/9u0bF5RLEAw6D5w7dyVhypQZJ2/fvq0DFcILBmUSevr0hc7s2fNP7tmzNwEqhBMM2jzw8+cfrs2bd84nlKQGfSYGJalJk6aewZWk8DYlXr58KXnmzJnwhw+fur169Vbn48eP4v/+/WODStMVsLOzfHNzc852cXFeABUCA6weeP/+vdC2bTuazpy5mDpQDsYFjIx0FoaEBOdwc3N/AfExPHDx4iWrdeu2rPrw4YM0VGjQAW1ttQ1paSmBIDaKB86cOeu0YsX6Lb9//+KECg06YGCgvSQsLCQTIwbu3bunMXPmvNM/fvziAQsMMoA3DwDTOdOECZOPATOrOVQcDjg42L6YmBhM1tLSXKeqqnqJjY3tF1SKJiA/vwwjU0pIiN0ICfEPBdp/BSoEB2APHDx4MHzduq0roGJwICcnfSYqKixQUlLyCVSI5gDdA+iZFh2A64ELFy7ngnlIQExM+G5qaqILPR2PDEBJxtfXPTE+Pi4Bl+NBgOn169fiDx48sYLy4cDNzSmTj4/vI5RLVyApKXodGHjm6OkdG2C6deuWBTAPMEL5YCAmJnrL1NR0N5RLVwBMMgvy8rJNsKX3T58+8R/avj778K7NqSA2SIwJWGmpgGWRgKys5CEok+4AmGQSubi4vkG5cABy8McJnufstgVNsd3sN+tjn/uFd2/fijD9/fuPFaoGDjg5Od5AmYMGXDi6J1b29TElKJdB9u0JhSunDkYM+sYcDPz79QOjfvr35a30kPEALsDExsaKUUTx8HA/hTIHD/j7mx3KQgBm1p9MVlZWS0REhO5BhRhERAQemJmZYVRqAw2Yv7yQgTLhgJGV8zO4Jgbl8KNHj8YyMzP/srCwWImt/Af1is6tnjDVJr4qESpEV3C/xeWG4su96lAuGJyMOBCI0hrFBe7cua3NsLpghcqzbToMk/+j1Bn0AOdOn3QxWmSBUi/9Y2L6/6b6uRTBTHxkz/YEyZlWp8COHwAASh1COyqmQblwcEU++riYmNgLnB4AJZkjC9vm22z0ms/94w3R4zTUBM+fP5d5Ojtlj8KrA6pQITj4YhQ7BURjTUJ3bt/SYVqdu0rp+S5NqBAC0DgJff36lfvhg/tar66dCDQ9XZ3L/f0VRvl/VT70tGbRCgsmJqZ/GB4AJRnDnXFTByrUCYGvnGJfXmYcM1VSUr4B4sOTENDnPEcWtC0YyCRDCHxnE/hxK2xzAMzxIACPgROzytdbXO4KAHMGIXgpqP/sZdC8CD0Do8NQITCAx4BudF3sUcPGpVDuoAE/mXh+HTLvnc5asE8P3fEgMOjywC8Wrt9v+NRfPpOwufJVxnqPhpnDMnFx8edQaQyAsxRiXJ2zWvn5bg2oEAIMQEWGD2CtB1RU1a5I5K83PWLcuhAqNGgBzooM1JG2SahKOOK/LfErhwhGD2nQAFASIoRv37qpc7fV7dr/HBAXu5qBwlgFsWFgPcF1eEHrfGxyA4mxZuKhBHDmgaECRj0w0GDUAwMLGBgA4e74zibxwYgAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWaveSync);
export default __webpack_public_path__ + "static/media/icon-wave-sync.ff2d69418354408742e8ae8c87375a19.svg";
export { ForwardRef as ReactComponent };